export const blockIconsBusinessandpaymentsReceiptLongNew = (
	<span className='material-symbols-outlined'>receipt_long</span>
);
